import { ProspectDto } from '@zaplify/prospects';
import { getProspectEducationSorted, getProspectExperiencesSorted } from '../../../../../helpers/prospects';
import { getDateString } from '@zaplify/utils';

export const useFormattedContact = () => {
    const getContactData = (userContact: { userContactId: string; prospect: ProspectDto }) => {
        const { personId, phoneNumbers, experiences, education, linkedinProfileVerification, ...prospectData } =
            userContact?.prospect?.data;

        //getting stringified education & experiences & phonenumbers
        const formattedExperiences = getProspectExperiences(experiences);
        const formattedEducation = getProspectEducation(education);
        const formattedPhoneNumbers = getProspectPhoneNumbers(phoneNumbers);

        //Replacing hashtags cause csv breaks otherwise
        const linkedinDescription = prospectData?.linkedinDescription?.replace(/#/g, '');
        prospectData.linkedinDescription = linkedinDescription;

        return {
            id: userContact.userContactId,
            prospectId: userContact.prospect.id,
            ...prospectData,
            ...formattedPhoneNumbers,
            ...formattedExperiences,
            ...formattedEducation,
        };
    };

    return { getContactData };
};

export function getProspectExperiences(experiences) {
    if (Array.isArray(experiences) && experiences.length) {
        return experiences
            .sort((a, b) => getProspectExperiencesSorted(a, b))
            .reduce(
                (acc, curr, idx) => ({
                    ...acc,
                    [`experience ${idx + 1}`]: JSON.stringify(curr),
                }),
                {}
            );
    } else {
        return {};
    }
}

export function getProspectEducation(education) {
    if (Array.isArray(education) && education.length) {
        return education
            .sort((a, b) => getProspectEducationSorted(a, b))
            .reduce(
                (acc, curr, idx) => ({
                    ...acc,
                    [`education ${idx + 1}`]: JSON.stringify(curr),
                }),
                {}
            );
    } else {
        return {};
    }
}

export function getProspectPhoneNumbers(phoneNumbers) {
    if (Array.isArray(phoneNumbers) && phoneNumbers.length) {
        return phoneNumbers.reduce(
            (acc, curr, idx) => ({
                ...acc,
                [`phoneNumber ${idx + 1}`]: curr.number,
            }),
            {}
        );
    } else {
        return {};
    }
}
